import dropdownApi from "@/api/dropdown";
import { cloneDeep, isEmpty } from "lodash";

export default {
  actions: {
    async list({ commit }) {
      commit("setDropdownListLoader", true);
      const response = await dropdownApi.list();
      commit("setList", response.data.result);
      commit("setDropdownListLoader", false);
    },
    async listApplications({ commit }) {
      commit("setDropdownListLoader", true);
      const response = await dropdownApi.listFiltered("applicationDropdownValueId");
      commit("setList", response.data.result);
      commit("setDropdownListLoader", false);
    },
    async fetchRecord({ commit }, id) {
      const response = await dropdownApi.get(id);
      commit("setEdit", Object.assign({}, response.data.result));
      commit("setRecord", Object.assign({}, response.data.result));
    },
    async resetEdit({ commit }, record) {
      commit("setEdit", Object.assign({}, record));
    },
    async update({ commit, dispatch, state }, data) {
      const record = await dropdownApi.update(data);
      commit("setRecord", record);
      await dispatch("list");
      return state.record;
    },
  },
  getters: {
    getByAttributeName: state => attributeName => {
      return state.list.find(item => {
        return item.attributeName === attributeName;
      });
    },
    getById: state => findId => {
      return state.list.find(item => {
        return item.id === findId;
      });
    },
    getDropdownValueFromValueList: state => findId => {
      let dropdown = {};
      state.list.forEach(item => {
        item.valueList.find(value => {
          if (value.id === findId) {
            dropdown = value;
          }
        });
      });
      return dropdown;
    },
    getActiveApplicationList: state => {
      if (isEmpty(state.list)) {
        return;
      }

      const clonedList = cloneDeep(state.list);

      const applicationList = clonedList.filter(({ attributeName }) => {
        return attributeName === "applicationDropdownValueId";
      });

      const activeApplicationList = applicationList[0].valueList.filter(({ isDeprecated }) => {
        return !isDeprecated;
      });
      return activeApplicationList;
    },
  },
  mutations: {
    setDropdownListLoader(state, isLoading) {
      state.isLoadingDropdownList = isLoading;
    },
    setEdit(state, dropdown) {
      state.edit = dropdown;
    },
    setRecord(state, dropdown) {
      state.record = dropdown;
    },
    setList(state, list) {
      state.list = list;
    },
  },
  namespaced: true,
  state: {
    edit: {},
    isLoadingDropdownList: false,
    list: [],
    record: {},
  },
};
